//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: 'my-datepicker',
    props: ['startDate', 'endDate', 'status', 'disable', 'endYear', 'yIndex'],
    data () {
        return {
            slots: [
                {
                    flex: 1,
                    values: [],
                    defaultIndex: 0,
                    className: 'slot1',
                    textAlign: 'right'
                }, {
                    flex: 1,
                    values: ['01', '02', '03', '04', '05', '06'],
                    defaultIndex: 0,
                    className: 'slot3',
                    textAlign: 'center'
                }, {
                    flex: 1,
                    values: ['01', '02', '03', '04', '05', '06'],
                    defaultIndex: 0,
                    className: 'slot3',
                    textAlign: 'left'
                }
            ],
            maxDate: '',
            minDate: '',
            maxYear: '',
            disableDate: [],
            isShow: false,
            curValue: '',
            showValue: '',
            yearIndex: 0
        }
    },
    methods: {
        onValuesChange (e, v) {
            let d = v.join('-')
            this.curValue = d
            this.showValue = v[0] + '年' + v[1] + '月' + v[2] + '日'
            if (this._.dateTab(d, this.maxDate)) {
                let dt = (new Date(this.maxDate))
                e.setValues([
                    dt.getFullYear().toString(),
                    this._.addZero(dt.getMonth() + 1, 2),
                    this._.addZero(dt.getDate(), 2)
                ])
            } else if (this._.dateTab(this.minDate, d)) {
                let dt = (new Date(this.minDate))
                e.setValues([
                    dt.getFullYear().toString(),
                    this._.addZero(dt.getMonth() + 1, 2),
                    this._.addZero(dt.getDate(), 2)
                ])
            } else if (this.disableDate.length > 0 && this.disableDate.includes(d)) {
                let dt = (new Date(this.getNormalDate(d)))

                this.slots[1].defaultIndex = dt.getMonth() // 设置默认选择月份
                this.slots[2].defaultIndex = dt.getDate() - 1
                e.setValues([
                    dt.getFullYear().toString(),
                    this._.addZero(dt.getMonth() + 1, 2),
                    this._.addZero(dt.getDate(), 2)
                ])
            }
        },
        init () {
            /* 获取当前时间和一年之后的时间 */
            let sdate = this._.getAfterNDate(0)
            let edate = this._.getAfterNDate(1, 'y')
            console.log(sdate, edate)
            /* 获取当前时间和一年之后的时间 */
            if (this.maxYear) {
                let _y = this.maxYear
                this.slots[0].values = Array.from({length: 100}, (v, k) => _y - k)
            } else {
                /* 左边年份 */
                this.slots[0].values = [sdate.getFullYear().toString(), edate.getFullYear().toString()]
            }
            /* set月份 */
            this.slots[1].values = Array.from(Array(12), (x, i) => this._.addZero(i + 1, 2))
            /* set月份 */

            /* set日期 */
            this.slots[2].values = Array.from(Array((new Date(sdate.getFullYear(), sdate.getMonth() + 1, 0)).getDate()), (x, i) => this._.addZero(i + 1, 2))
            /* set日期 */

            this.slots[0].defaultIndex = this.yearIndex || 0 // 设置默认选择年份

            this.slots[1].defaultIndex = sdate.getMonth() // 设置默认选择月份

            this.slots[2].defaultIndex = sdate.getDate() - 1
            this.minDate = this.startDate || this._.dateFormat(sdate, 'yyyy-MM-dd')
            this.maxDate = this.endDate || this._.dateFormat(edate, 'yyyy-MM-dd')
        },
        getMonthDay (Year, Month) {
            let monthDay = Array.from(Array((new Date(Year, Month, 0)).getDate()), (x, i) => this._.addZero(i + 1, 2))
            this.slots[2].values = monthDay
        },
        close () {
            this.$emit('close', false)
        },
        ok () {
            this.$emit('confirm', this.curValue)
        },
        beforeEnter (e) {
            e.style.transform = 'translateY(4.88rem)'
        },
        enter (e, done) {
            setTimeout(() => {
                e.style.transform = 'translateY(0)'
                e.style.transition = 'all .3s ease'
                done()
            }, 1)
        },
        getNormalDate (v) {
            if (!this._.dateTab(v, this.maxDate) && !this._.dateTab(this.minDate, v) && !this.disableDate.includes(v)) {
                return v
            }
            let _m = this._.dateFormat(this._.getAfterNDate(v, 1, 'd'), 'yyyy-MM-dd')
            return this.getNormalDate(_m)
        }
    },
    created () {
        if (this.endYear) {
            this.maxYear = this.endYear
        }
        if (this.startDate) {
            this.minDate = this.startDate
        }
        if (this.endDate) {
            this.maxDate = this.endDate
        }
        if (this.yIndex) {
            this.yearIndex = this.yIndex
        }
        this.init()
    },
    watch: {
        startDate (v) {
            this.minDate = v
            let sdate = new Date(v)
            this.slots[1].defaultIndex = sdate.getMonth()
            this.slots[2].defaultIndex = sdate.getDate() - 1
        },
        endDate (v) {
            this.maxDate = v
        },
        endYear (v) {
            this.maxYear = v
        },
        status (v) {
            this.isShow = v
        },
        disable (v) {
            this.disableDate = v
        }
    }
}
